import React from 'react';
import * as S from './style';
import { ReactComponent as IconPlus } from 'assets/img/common/ic_plus_2.svg';
import { ItemInfoContainer, ContentsContainer } from 'components';
import { Props as UserItemProps } from 'components/molecules/UserItem';
import { TITLE_USER_LIST, BUTTON_ADD_USER } from 'commons/ZimssaString';

interface Props {
    children: React.ReactNode;
    isOwner: boolean;
    userItems?: Array<UserItemProps>;
    onClickAdd: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClickMore?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function UserList({ children, isOwner, onClickAdd }: Props): React.ReactElement {
    return (
        <S.MemberList>
            <ContentsContainer
                title={TITLE_USER_LIST}
                option={
                    <S.BtnAddMemberWrapper>
                        {/*직책이 소장일 경우에만 직원 추가 버튼을 노출한다*/}
                        {isOwner ? (
                            <S.BtnAddMember color={'blue_900'} fontStyle={'body2'} backGroundColor={'transparent'} onClick={onClickAdd}>
                                <S.SvgWrapper>
                                    <IconPlus />
                                </S.SvgWrapper>
                                {BUTTON_ADD_USER}
                            </S.BtnAddMember>
                        ) : null}
                    </S.BtnAddMemberWrapper>
                }
            >
                <ItemInfoContainer>{children}</ItemInfoContainer>
            </ContentsContainer>
        </S.MemberList>
    );
}

export default UserList;
